import {DateTime} from "luxon"

import {MC} from './MC.js'
import {Value} from './Value.js'

const MCHistory = {

  historyArr: [],
  logArr: [],
  flowInstance: {},
  T_ERROR: 'ERROR',
  T_EXCEPTION: 'EXCEPTION',
  T_WARNING: 'WARNING',
  T_INFO: 'INFO',

  log: function(type, text, debug) {
    if (MC.isNull(type) || MC.isNull(text)) {
      console.error("Bad log function calling!")
    }
    if (debug) {
      this.logArr.push({type: type, mess: text, time: new Date()})
      if (type == this.T_ERROR) {
        console.error(this.T_ERROR + ' - ' + (new Date()).toISOString() + ': ' + text)
      } else if (type == this.T_EXCEPTION) {
        console.error(this.T_EXCEPTION + ' - ' + (new Date()).toISOString() + ': ' + text)
      } else if (type == this.T_WARNING) {
        console.warn(this.T_WARNING + ' - ' + (new Date()).toISOString() + ': ' + text)
      } else {
        console.log(this.T_INFO + ' - ' + (new Date()).toISOString() + ': ' + text)
      }
    }
  },

  history: function(flowObject, action, text, logObject, opts) {
    if (MC.isNull(flowObject)) {
      console.error("Bad log function calling!")
    }
    if (flowObject.debug('MINIMAL')) {
      let atleastBasic = flowObject.debug('BASIC')
      if (!atleastBasic && (!logObject || !logObject.executionId)) { // for logging tree in minmal for debugger, if not has children do not log
        return
      }  
      if (atleastBasic) {
        this.putFlowInstanceInfo(flowObject)
      }
      let flow = flowObject.flow
      let oldRec = null
      let record = {}
      if (action && (action.kind == 'call' || action.kind == 'framework') && opts && logObject.executionId) {
        oldRec = this.historyArr.find(oe => oe.actionid == action.id && oe.executionActionId == logObject.executionId)
        if (oldRec) {
          record = oldRec
          delete record.text
          delete record.archived
        }
      }
      if (!atleastBasic) { // for logging tree in minmal for debugger
        record.archived = true
      }
      if (atleastBasic) {
        record.path = MCHistory.getFlowPath(flowObject)
        if (opts) {
          if (opts.start) {
            record.start = MC.luxonToDateTimeString({v: DateTime.fromMillis(opts.start)})
          }
          if (opts.end) {
            record.end = MC.luxonToDateTimeString({v: DateTime.fromMillis(opts.end)})
          }
          if (opts.duration !== undefined) {
            record.duration = Math.round(opts.duration * 1000)
          }
          if (opts.logic) {
            record.logic = {name: opts.logic.name, id: opts.logic.rbsid}
          }
        }
        if (flow) {
          record.flow = flow.id
          record.flowKind = flow.kind
        }
      }
      if (!MC.isNull(action)) {
        record.action = action.code
        record.kind = action.kind
        record.actionid = action.id
      } else if (flow) {
        record.kind = flow.kind
      }
      if (atleastBasic && logObject && logObject.target) {
        if (record.kind == 'call' || record.kind == 'dialog' || record.kind == 'framework') {
          record.target = {id: logObject.target.rbsid, name: logObject.target.id, component: logObject.target.model, type: 'operation', kind: logObject.target.kind}
        } else if (record.kind == 'form') {
          record.target = {id: logObject.target.formId, name: logObject.target.id, component: logObject.target.model, type: 'form', kind: 'form'}
        } 
        delete logObject.target
      }
      record.text = text
      record.instanceId = flowObject.instanceId
      if (logObject && logObject.executionId) {
        record.executionActionId = logObject.executionId
        delete logObject.executionId
      }
      if (logObject && logObject.isException) {
        record.isException = true
        delete logObject.isException
        if (logObject.exceptionHandled) {
          record.exceptionHandled = true
          delete logObject.exceptionHandled
        }
      }
      record.logObject = record.logObject || {} 
      if (!MC.isNull(logObject) && MC.isPlainObject(logObject) && flowObject.debug('DETAIL')) {
        for (let root in logObject) {
          if (!MC.isNull(logObject[root])) { // filter null objects
            if (['Input', 'Environment', 'Output'].indexOf(root) > -1) {
              if (!Value.isNullishOrEmpty(logObject[root])) {
                record.logObject[root] = Value.toLiteral(logObject[root])
              }
            } else {
              record.logObject[root] = logObject[root]
            }
          }
        }
      }
      if (!oldRec) {
        this.historyArr.push(record)
      }
      if (atleastBasic) {
        console.log((record.path ? record.path + ' / ' : '') + record.flow + (record.action ? ' / ' + record.action : '')  + ' (' + record.kind + ')' + (record.duration !== undefined ? ' -  ' +  (record.duration/1000).toFixed(1) + 'ms (' + record.end + ')' : '') + (record.text ? ' - ' + record.text : ''))
        if (!MC.isNull(record.logObject) && flowObject.debug('DETAIL')) {
          for (let root in record.logObject) {
            console.log('       ' + root + ':', record.logObject[root])
          }
        }
      }
    }
  },

  putFlowInstanceInfo(flowObject) {
    if (!this.flowInstance[flowObject.instanceId]) {
      let operation = flowObject.flow ? Value.dataNode({name: Value.v(flowObject.flow.id, 'string'), component: Value.v(flowObject.flow.model, 'string'), id: Value.v(flowObject.flow.rbsid, 'string'), kind: Value.v(flowObject.flow.kind, 'string')}) : Value.v(null)
      let finfo = {flowConfiguration: Value.v(flowObject.confPath, 'string'), operation: operation, authenticatedUser: Value.v(flowObject.context.data.env.value.system ? flowObject.context.data.env.value.system.value.userLoginId.value : null, 'string'), parentExecutionId: Value.v(flowObject.parentFlow ? flowObject.parentFlow.instanceId : null, 'string')}
      this.flowInstance[flowObject.instanceId] = finfo
    }
  },

  getHistory: function() {
    return this.historyArr
  },

  getLog: function() {
    return this.logArr
  },

  clear: function() {
    let newHistory = []
    for (let rec of this.historyArr) {
      if (rec.executionActionId) {
        rec.logObject = {}
        rec.archived = true
        newHistory.push(rec)
      }
    }
    this.historyArr = newHistory
    this.logArr = []
    this.flowInstance = {}
    console.clear()
  },

  getFlowPath: function(flow) {
    if (flow.parentFlow) {
      var result = ''
      var sep = ''
      while (flow.parentFlow) {
        result =  flow.parentFlow.flow.id + sep + result
        sep = ' / '
        flow = flow.parentFlow
      }
      return result
    } else {
      return null
    }
  },

  listFLowLog: function(executionId, tree = false) {
    let res = {executionId: Value.v(executionId, 'string')}
    if (this.flowInstance[executionId]) {
      res = Object.assign(res, this.flowInstance[executionId])
    }
    let executedAction = []
    for (let rec of this.historyArr) {
      if (rec.instanceId == executionId) {
        let action = {id: Value.v(rec.actionid, 'string'), kind: Value.v(rec.kind, 'string'), name: Value.v(rec.action, 'string')}
        let act = {}
        act.start = Value.v(rec.start, 'string')
        act.end = Value.v(rec.end, 'string')
        act.duration = Value.v(rec.duration, 'integer')
        act.message = Value.v([Value.v(rec.text, 'string')], 'collection')
        act.archived = Value.v(rec.archived ? true : false, 'boolean')
        if (tree) {
          if (rec.executionActionId && !rec?.logObject['Server log']) {
            act.execution = MCHistory.listFLowLog(rec.executionActionId, true)
          } else {
            act.execution = Value.dataNode({})
          }
        } else {
          act.executionId = Value.v([Value.v(rec.executionActionId, 'string')], 'collection')
        }
        if (rec.logic) {
          act.event = Value.dataNode({kind: Value.v('FORM LOGIC', 'string'), name: Value.v(rec.logic.name, 'string'), id: Value.v(rec.logic.id, 'string')})
        } else if (rec.text) {
          let index = rec.text.indexOf(': ')
          if (index > 0) {
            act.event = Value.dataNode({kind: Value.v(rec.text.substring(0, index), 'string'), name: Value.v(rec.text.substring(index + 2), 'string')})
          } else {
            act.event = Value.dataNode({kind: Value.v(rec.text, 'string')})
          }
        }
        if (rec.target) {
          action.target = Value.dataNode({id: Value.v(rec.target.id, 'string'), name: Value.v(rec.target.name, 'string'), component: Value.v(rec.target.component, 'string'), type: Value.v(rec.target.type, 'string'), kind: Value.v(rec.target.kind, 'string')})
        }
        act.action = Value.dataNode(action)
        if (rec.logObject) {
          if (rec.logObject.Input) {
            act.input = Value.dataNode({value: Value.dataNode({data: Value.fromJson(rec.logObject.Input, true)})})
          }
          if (rec.logObject.Output) {
            act.output = Value.v([Value.dataNode({data: Value.fromJson(rec.logObject.Output, true)})], 'collection')
          }
          if (rec.isException) {
            act.exception = Value.dataNode({data: Value.fromJson(rec.logObject.Output, true)})
            act.exceptionHandled = Value.v(rec.exceptionHandled === true, 'boolean')
          }
          if (rec.logObject['Server log']) {
            const serverSide = Value.dataNode({flowId: Value.v(rec.logObject['Server log'].flowId, 'string'), flowLogId: Value.v(rec.logObject['Server log'].flowLogId, 'string')})
            if (tree) {
              act.execution.value.serverSide = serverSide
              act.execution.value.flowConfiguration = Value.v(rec.logObject['Server log'].flowConfiguration, 'string')
            } else {
              act.serverSide = serverSide
            }
          }
          if (rec.logObject['Tested branches']) {
            let condition = []
            for (let name in rec.logObject['Tested branches']) {
              const branchInfo = rec.logObject['Tested branches'][name]
              // trace is an arbitrary, dynamically-shaped expression evaluation trace (array or object) - fromJson is required to preserve that shape
              condition.push(Value.dataNode({branch: Value.v(name, 'string'), value: Value.fromJson(branchInfo.result, true), trace: Value.fromJson(branchInfo.trace)}))
            }
            act.condition = Value.v(condition, 'collection')
          }
          if (rec.logObject['Condition']) {
            const conditionInfo = rec.logObject['Condition']
            act.condition = Value.v([Value.dataNode({branch: Value.v('condition', 'string'), value: Value.fromJson(conditionInfo.result, true), trace: Value.fromJson(conditionInfo.trace)})], 'collection')
          }
          if (rec.logObject.Trace) {
            let mapping = []
            for (let path in rec.logObject.Trace) {
              const traceEntry = rec.logObject.Trace[path]
              mapping.push(Value.dataNode({target: Value.v(path, 'string'), value: Value.dataNode({data: Value.fromJson(traceEntry.result, true)}), trace: Value.fromJson(traceEntry)}))
            }
            act.input = Value.dataNode({value: act.input ? act.input.value.value : Value.v(null), mapping: Value.v(mapping, 'collection')})
          }
          if (rec.logObject['Environment']) {
            act.environment = Value.fromJson(rec.logObject['Environment'], true)
          }
        }
        executedAction.push(Value.dataNode(act))
      }
    }
    res.executedAction = Value.v(executedAction, 'collection')
    return Value.dataNode(res)
  }

}

export {MCHistory}